import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import AssetBackend from '@utils/i18n/asset-backend'
import serverLangDetector from '@utils/i18n/server-lang-detector'

export const languages = Object.freeze([
  { code: 'en-US', label: 'English (US)' },
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
  { code: 'es-ES', label: 'Español (ES)' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'ja', label: '日本語' },
  { code: 'ca', label: 'Català' },
  { code: 'zh-CN', label: '中文 (简体中文)' },
  { code: 'zh-TW', label: '中文 (繁體)' },
])

const languageDetector = new LanguageDetector()
languageDetector.addDetector(serverLangDetector)

let instance = i18n.use(languageDetector).use(initReactI18next)

// don't attempt to request translations from manifest during tests
if (process.env.NODE_ENV !== 'test') {
  instance = instance.use(AssetBackend)
}

instance.init({
  initImmediate: false,
  detection: {
    order: [
      'server-lng', // Highest priority uses custom language detector `serverLangDetector`
      'querystring',
      'cookie',
      'localStorage',
      'sessionStorage',
      'navigator',
      'htmlTag',
    ],
    caches: ['localStorage'],
    excludeCacheFor: ['cimode'],
  },
  supportedLngs: languages.map((lng) => lng.code),
  fallbackLng: 'en',
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
})

export default i18n
